import { render } from "./LimitsModal.vue?vue&type=template&id=68ec9dd7&scoped=true"
import script from "./LimitsModal.vue?vue&type=script&lang=js"
export * from "./LimitsModal.vue?vue&type=script&lang=js"

import "./LimitsModal.vue?vue&type=style&index=0&id=68ec9dd7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ec9dd7"]])

export default __exports__